import React, { useEffect, useState, useRef } from "react";
import SchoolHeader from "../components/SchoolHeader";
import Footer from "../components/Footer";
import { MyCreatedFilesStructure } from "../components/common-components/FileSystem/MyCreatedFileStructure";
import { Container, Card, Form, Row, Col, Button } from "react-bootstrap";
import { FaFolder } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import Calendar from "react-calendar";
import Dropdown from 'react-bootstrap/Dropdown';
import "react-calendar/dist/Calendar.css";
import { Modal } from "react-bootstrap";
import LoadingBar from "../components/common-components/toaster/loader/loader";
import { DataGrid } from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker"
import { MultiSelect } from "react-multi-select-component";
import { SetUserDetailsToLocal, showSuccessMessage, getUserDetailsfromLocal } from "../services/utils";
import { authServices } from "../services/auth.services";
import { SignaturedContracts } from "../components/common-components/FileSystem/signaturedContracts";
import { useNavigate } from "react-router-dom";
import schoolServices from "../services/school_services";
import { FileStructure } from "../components/common-components/FileSystem/FileStructure";
import moment from 'moment'
import { showErrorMessage } from "../services/utils";
import _ from 'lodash';

import RotationReq from "../components/common-components/ShiftRotation/RotationReq";
const columns = [
    { field: "hospitalInfo", headerName: "Hospital", sortable: false, width: 130 },
    {
        field: "departmentInfo",
        headerName: "Type of rotation",
        sortable: false,
        width: 130,
    },
    {
        field: "date",
        headerName: "Date",
        sortable: false,
        width: 185,
    },
    {
        field: "time",
        headerName: "Time",
        sortable: false,
        width: 185,
    },
    {
        field: "day",
        headerName: "Days For rotation",
        sortable: false,
        width: 300,
    },
    {
        field: "status",
        headerName: "Approval Status",
        sortable: false,
        width: 150,
        renderCell: (params) => {
            return (
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                >
                    {
                        params?.value === "approved" ?
                            <Chip label="Approved" size="small" color="success" /> :
                            params?.value === "disapproved" ?
                                <Chip label="Rejected" size="small" color="error" /> :
                                <Chip label="Under review" size="small" color="primary" />
                    }
                </div>
            );
        },
    },
    // {
    //     field: "action",
    //     headerName: "Action",
    //     sortable: false,
    //     width: 150,
    //     renderCell: (params) => {
    //         return (
    //             <div
    //                 className="d-flex justify-content-between align-items-center"
    //                 style={{ cursor: "pointer" }}
    //             >
    //                 <span className="actn_icn">
    //                     <FaEye title="View" />
    //                 </span>
    //                 <span className="actn_icn">
    //                     <FaUndoAlt title="Reschedule" />
    //                 </span>
    //                 <span className="actn_icn">
    //                     <FaTrashAlt title="Delete" />
    //                 </span>
    //             </div>
    //         );
    //     },
    // },
];
const DayOptions = [{
    label: "Sunday",
    value: "sunday",
    id: new Date().getMilliseconds()
},
{
    label: "Monday",
    value: "monday",
    id: new Date().getMilliseconds()
},
{
    label: "Tuesday",
    value: "tuesday",
    id: new Date().getMilliseconds()
},
{
    label: "Wednesday",
    value: "wednesday",
    id: new Date().getMilliseconds()
},
{
    label: "Thursday",
    value: "thursday",
    id: new Date().getMilliseconds()
},
{
    label: "Friday",
    value: "friday",
    id: new Date().getMilliseconds()
},
{
    label: "Saturday",
    value: "saturday",
    id: new Date().getMilliseconds()
},
]


const SchoolDashboard = () => {
    const formRef = useRef(null);
    const Administrative_Ref = useRef(null);
    const Contracts_Ref = useRef(null);
    const Files_Ref = useRef(null);
    const userDetails = JSON.parse(getUserDetailsfromLocal())
    const navigate = useNavigate()
    const [selected, setSelected] = useState([]);
    const [profileData, setProfileData] = useState()
    const [UtilityList, setUtilityList] = useState({ departmentList: [], hospitalList: [], programList: [], allRotationReq: [], dayRotation: [], studentList: [] })
    const [date, onChange] = useState(false);
    const [schoolInfo, SetSchoolInfo] = useState()
    const [files, setFilesData] = useState()
    const [programs, setPrograms] = useState()
    const [fileOpen, setFileOpen] = useState({ isFileOpen: false, isFolderOpen: false })
    const [rotationReq, setRotationReq] = useState()
    const [loading, setLoading] = useState(false)
    const [idSchool, setIdSchool] = useState(false)
    const [fileName, setFileName] = useState();
    const [filterdata, setFilterdata] = useState({ select: false, data: "" })
    const [folderName, setFolderName] = useState({})
    const [modalOpen, setModalOpen] = useState(false)
    const [myCreatedFile, setMyCreatedFiles] = useState({})
    const [signaturedFolders, setSignaturedFolders] = useState([])
    const testVar = []
    const modalToggle = () => {
        setModalOpen(!modalOpen)
    }


    const getSchoolPrograms = () => {
        authServices.getSchoolPro().then(resp => {
            setUtilityList(prev => ({ ...prev, "programList": resp.data }))
            setPrograms(resp.data)
        }).catch(err => { console.log(err) })
    }

    const getHospitaList = () => {
        schoolServices.getHospitalList().then(resp => {
            setUtilityList(prev => ({ ...prev, "hospitalList": resp.data.data }))
        }
        ).catch(err => {
            console.log(err)
        })
    }

    const getDepartments = () => {
        schoolServices.getRotationsDprtmnts()
            .then(resp => {
                setUtilityList(prev => ({ ...prev, "departmentList": resp.data.data }))
            }
            )
            .catch(err => {
                console.log(err)
            })
    }



    useEffect(() => {
        getSchoolPrograms()
        getSchoolProfile()
        getHospitaList()
        getDepartments()
    }, [])

    useEffect(() => {
        signauredDocsFolder("folder")
        getAllRotationReq()

    }, [date])

    const getSchoolProfile = async () => {
        await schoolServices.getSchoolProfile().then(resp => {
            setProfileData(resp.data)
            setIdSchool(resp.data.schoolInfoData.school_id)
            SetSchoolInfo(resp.data.schoolInfoData)
            SetUserDetailsToLocal({ user: resp.data.school })
            // getStudentList(resp.data.schoolInfoData.school_id)
            getAllRotationReq(resp.data.schoolInfoData.school_id)
            getMyFiles(resp.data.schoolInfoData.school_id)
            getAdministrativeFiles(resp.data.schoolInfoData.school_id)

        }).catch(err => {
            console.log(err, "<---------getSchoolProfile")
        })
    }

    const getAllRotationReq = (argData) => {
        setLoading(true)
        let data
        if (date) {
            data = {
                schoolId: argData ? argData : idSchool,
                RotationDate: date && date
            }
        }
        else {
            data = {
                schoolId: argData ? argData : idSchool,
            }
        }

        schoolServices.getAllRotationReq(data).then(resp => {
            if (!date) {
                setUtilityList(prev => ({ ...prev, "allRotationReq": [] }))
                resp.data.data.map(curr => {
                    curr.id = curr._id
                    curr.day = curr.days.map(curr => { return curr })
                    curr.hospitalInfo = curr.hospitalInfo.hospital_name
                    curr.departmentInfo = curr.departmentInfo.department
                    curr.date = `${moment(curr.start_date).format("MM/DD/YYYY")} - ${moment(curr.end_date).format("MM/DD/YYYY")}`
                    curr.time = `${curr.start_time}-${curr.end_time}`
                    setUtilityList(prev => ({ ...prev, "allRotationReq": [...prev.allRotationReq, curr] }))
                })
            }
            else {

                setUtilityList(prev => ({ ...prev, "dayRotation": resp.data.data }))
            }
            setLoading(false)

        }
        ).catch(err => {
            setLoading(false)
            console.log(err)
        })
    }

    const handleChange = (e) => {
        setRotationReq({
            ...rotationReq,
            [e.target.name]: e.target.value
        })
    }

    const getAdministrativeFiles = async (data) => {

        await schoolServices.getAdministrativeFiles(data).then(resp => {
            setFilesData(resp.data)
        }).catch(err => {
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }

    const SubmitRotation = (e) => {
        e.preventDefault()
        setLoading(true)
        selected && selected.map(curr => {
            testVar.push(curr.value)
        })
        rotationReq.days = testVar
        rotationReq.school_id = userDetails?._id
        delete rotationReq.startTime
        delete rotationReq.endTime

        schoolServices.MakereqForRotation(rotationReq).then(resp => {
            setUtilityList(prev => ({ ...prev, "allRotationReq": [] }))
            onChange()
            setSelected([])
            setRotationReq({ clinical_start_date: "", department_id: "" })
            getAllRotationReq()
            setLoading(false)
            setRotationReq("")
            setSelected("")
            formRef.current.reset();
            showSuccessMessage({ message: "Your Request Has been Submitted" })
        }).catch(err => {
            setLoading(false)
            showErrorMessage({ message: err.response.data.errors.msg[0].msg ? err.response.data.errors.msg[0].msg : err.response.data.errors.msg })
            console.log(err)

        })


    }

    const getMyFiles = async (data) => {
        const schoolId = data ? data : idSchool
        await schoolServices.getFileFolder(schoolId).then(resp => {
            setMyCreatedFiles(resp.data.list)
            setLoading(false)
        }).catch(err => {
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }
    const createFile = async (data) => {
        setLoading(true)
        await schoolServices.createFileFolder(data).then((resp) => {
            setLoading(false)
            showSuccessMessage({ message: "Created successfully" })
            getMyFiles()
        }).catch(err => {
            setLoading(false)
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }

    const deleteFile = (obj) => {
        schoolServices.deleteFileFolder(obj).then(resp => {
            getMyFiles()
            showSuccessMessage({ message: "File Removed" })
        }).catch(err => setLoading(false))
    }

    const shareFolders = (data) => {
        const obj = {
            custom_file_id: data.custom_file_id,
            shared_to: data.shared_to,
            shared_users: data.shared_users
        }
        schoolServices.shareSchoolFolders(obj).then(resp => {
            showSuccessMessage({ message: "File Shared" })
        }).catch(err => {
            console.log(err, "<-- File ")
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }

    const signauredDocsFolder = (queryId, queryName) => {
        schoolServices.getSignaturedDocs(queryId, queryName).then(resp => {
            setSignaturedFolders(resp.data.list)
        })
    }

    const administrativeQuery = _.debounce((type, value) => {
        setLoading(true)
        schoolServices.getAdministrativeFiles(type, `&name=${value}`).then(resp => {
            setLoading(false)
            !resp.data.length > 0 ? showErrorMessage({ message: " NO Data Found" }) : showSuccessMessage({ message: " Found exact match" })

            setFilesData(resp.data)
            Administrative_Ref.current.scrollIntoView({ behavior: "smooth" })
        }).catch(err => {
            setLoading(false)

            showErrorMessage({ message: err.response.data.errors.msg })
        })

    }, 1000);

    const contractQuery = _.debounce((id, value) => {
        setLoading(true)
        schoolServices.getSignaturedDocs(id, `&school_name=${value}`).then(resp => {
            setLoading(false)
            !resp.data.list > 0 ? showErrorMessage({ message: " NO Data Found" }) : showSuccessMessage({ message: " Found exact match" })
            Contracts_Ref.current.scrollIntoView({ behavior: "smooth" })

            setSignaturedFolders(resp.data.list)
        }).catch(err => {
            setLoading(false)
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }, 1000);

    const filesQuery = _.debounce((type, value) => {
        setLoading(true)
        schoolServices.getFileFolder(type, `&name=${value}`).then(resp => {
            setLoading(false)
            !resp.data.list > 0 ? showErrorMessage({ message: " NO Data Found" }) : showSuccessMessage({ message: " Found exact match" })
            Files_Ref.current.scrollIntoView({ behavior: "smooth" })

            setSignaturedFolders(resp.data.list)
        }).catch(err => {
            setLoading(false)
            showErrorMessage({ message: err.response.data.errors.msg })
        })
    }, 1000);

    const filterQuery = (e) => {

        if (filterdata.type === "Administrative") {
            administrativeQuery(profileData.schoolInfoData.school_id, filterdata.data)

        } else if (filterdata.type === "Contracts") {


            contractQuery(idSchool, filterdata.data)


        }
        else if (filterdata.type === "files") {


            filesQuery("folder", filterdata.data)

        }


    }


    return (
        <div className="dashbrd_pg muiheight">
            <SchoolHeader />
            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    {loading && <LoadingBar />}
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4 db-sub-btn">
                            <h2>School Dashboard</h2>

                            <Form id="form1">
                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlTextarea1"
                                >
                                    <Form.Select aria-label="Default select example"
                                        name="hospital_id"
                                        onChange={(e) => {
                                            if (e.target.value === "none") {
                                                setFilterdata({ select: false })

                                            } else {
                                                setFilterdata({ select: true, type: e.target.value })

                                            }

                                        }}
                                        required
                                    >
                                        <option value={`none`}>Filter By </option>
                                        <option value={`Administrative`} >Administrative Files </option>
                                        <option value={`files`}> MyFiles </option>
                                        <option value={`Contracts`}>Student Contracts</option>

                                    </Form.Select>
                                </Form.Group>

                                {filterdata.select && <div className="d-flex">
                                    <Form.Control
                                        value={filterdata.data}
                                        type={"text"}
                                        placeholder={`Search in here...`}
                                        onChange={(e) => {
                                            setFilterdata({ ...filterdata, data: e.target.value })
                                        }}

                                    />
                                    <Button
                                        className="btn_theme "
                                        onClick={(e) => {
                                            filterQuery(e)
                                        }}
                                    >
                                        {<FaChevronRight />}
                                    </Button>



                                </div>}
                            </Form>


                            <div className="db-sub-btn">
                                <div style={{ marginLeft: "10px" }}>
                                    {profileData?.is_auth_sub_admin ? profileData?.auth_sub_admin_privilege?.my_files === "true" && <div style={{ marginLeft: "10px" }}>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="" className="btn_theme" id="dropdown-basic">
                                                Create Document
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }) }}>File</Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }) }}>Folder</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div> : <div style={{ marginLeft: "10px" }}>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="" className="btn_theme" id="dropdown-basic">
                                                Create Document
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }) }}>File</Dropdown.Item>
                                                <Dropdown.Item onClick={() => { setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }) }}>Folder</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>}
                                </div>
                                {
                                    profileData && !profileData?.is_auth_sub_admin &&

                                    <div style={{ marginLeft: "10px" }}>
                                        <Dropdown>
                                            <Dropdown.Toggle style={{ width: "155px" }} variant="" className="btn_theme" id="dropdown-basic">
                                                +Add
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                {!profileData?.is_sub_admin && <Dropdown.Item onClick={() => { navigate(`/Co-User/school/${schoolInfo.user_id}`) }}>Co-User</Dropdown.Item>}
                                                <Dropdown.Item onClick={() => { navigate(`/Sub-Admin/school/${schoolInfo.user_id}`) }}>Sub-Admin</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                }


                            </div>
                        </div>
                        <Row>
                            <Col sm={7}>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                My Schedule
                                            </h4>
                                        </div>
                                        <div className="clndr_card d-flex">
                                            <div className="dash_clndr">
                                                <Calendar
                                                    onChange={(e) => { onChange(e) }}
                                                    value={!date ? "" : date}
                                                    minDate={new Date('01-01-2023')}
                                                />
                                            </div>
                                            <RotationReq studentList={UtilityList.studentList.length > 0 && UtilityList?.studentList} UtilityList={UtilityList.dayRotation.length > 0 && UtilityList?.dayRotation} />
                                        </div>
                                    </Card.Body>
                                </Card>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="card_hdng d-flex align-items-center justify-content-between">
                                            <h4 className="mb-0">
                                                My Approval Requests
                                            </h4>
                                            <div className="vw_all">
                                                <a href={`/pending-approval/${idSchool}`}>View all</a>
                                            </div>

                                        </div>
                                        <div className="apprvl_list">
                                            <div
                                                style={{
                                                    height: 400,
                                                    width: "100%",
                                                }}
                                            >
                                                <DataGrid
                                                    rows={UtilityList?.allRotationReq}
                                                    columns={columns}
                                                    pageSize={5}
                                                    rowsPerPageOptions={[5]}
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm={5}>
                                <Card className="pg_card">
                                    <Card.Body className="overAuto">
                                        <div className="card_hdng ">
                                            <h4 className="mb-0">
                                                Request for Rotation
                                            </h4>
                                        </div>
                                        <div className="prfl_flds">
                                            <Form onSubmit={(e) => { SubmitRotation(e) }} ref={formRef} id="form1">
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="exampleForm.ControlTextarea1"
                                                >
                                                    <Form.Label>
                                                        Select a Hospital{" "}
                                                    </Form.Label>
                                                    <Form.Select aria-label="Default select example"
                                                        name="hospital_id"
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        required
                                                    >
                                                        <option>
                                                            Select a Hospital
                                                        </option>
                                                        {UtilityList.hospitalList && UtilityList.hospitalList.length > 0 && UtilityList.hospitalList.map((curr, index) => {
                                                            return (
                                                                <option value={curr._id} id={curr._id}>{
                                                                    curr.hospitalInfo.hospital_name
                                                                }
                                                                </option>
                                                            )
                                                        })}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="exampleForm.ControlTextarea1"
                                                >
                                                    <Form.Label>
                                                        Select Type of Rotation{" "}
                                                    </Form.Label>
                                                    <Form.Select aria-label="Default select example"
                                                        name="department_id"
                                                        required
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                            e.target.value === '63c0048e0cbafef97fa26c09' && setModalOpen(true)
                                                        }}
                                                    >
                                                        <option>Select Type of Rotation</option>
                                                        {UtilityList.departmentList && UtilityList.departmentList.length > 0 && UtilityList.departmentList.map((curr, index) => {
                                                            return (
                                                                <option value={curr._id} id={curr._id}>{curr.department}
                                                                </option>
                                                            )
                                                        })}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="exampleForm.ControlTextarea1"
                                                >
                                                    <Form.Label>
                                                        Select Type of Program{" "}
                                                    </Form.Label>
                                                    <Form.Select aria-label="Default select example"
                                                        name="program_id"
                                                        required
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                            e.target.value === '63c0048e0cbafef97fa26c09' && setModalOpen(true)
                                                        }}
                                                    >
                                                        <option>Select Type of Program</option>
                                                        {UtilityList.programList && UtilityList.programList.length > 0 && UtilityList.programList.map((curr, index) => {
                                                            return (
                                                                <option value={curr._id} id={curr._id}>{curr.program_name}
                                                                </option>
                                                            )
                                                        })}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <Form.Label>
                                                            Program Start Date
                                                        </Form.Label>

                                                        <DatePicker
                                                            value={rotationReq?.clinical_start_date ? rotationReq.clinical_start_date : null}
                                                            placeholder="Enter Graduation Date"
                                                            className="form-control"
                                                            required
                                                            onChange={(newValue) => {
                                                                if (newValue && newValue._d != "Invalid Date") {
                                                                    setRotationReq({
                                                                        ...rotationReq,
                                                                        "clinical_start_date": newValue._d
                                                                    })
                                                                }
                                                            }}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    required
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>

                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >

                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <Form.Label>
                                                            Rotation Start Date
                                                        </Form.Label>

                                                        <DatePicker
                                                            value={rotationReq?.start_date ? rotationReq.start_date : null}
                                                            placeholder="Enter Graduation Date"
                                                            className="form-control"
                                                            required
                                                            onChange={(newValue) => {
                                                                if (newValue && newValue._d != "Invalid Date") {
                                                                    setRotationReq({
                                                                        ...rotationReq,
                                                                        "start_date": newValue._d
                                                                    })
                                                                }
                                                            }}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    required
                                                                />
                                                            )}
                                                            minDate={new Date()}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <Form.Label>
                                                            Rotation End Date
                                                        </Form.Label>

                                                        <DatePicker
                                                            value={rotationReq?.end_date ? rotationReq.end_date : null}
                                                            placeholder="Enter Graduation Date"
                                                            className="form-control"
                                                            required
                                                            onChange={(newValue) => {
                                                                if (newValue && newValue._d != "Invalid Date") {
                                                                    setRotationReq({
                                                                        ...rotationReq,
                                                                        "end_date": newValue._d
                                                                    })
                                                                }
                                                            }}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    required
                                                                />
                                                            )}
                                                            minDate={rotationReq?.start_date ? rotationReq.start_date : new Date()}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    <Form.Label>
                                                        Days For Rotation
                                                    </Form.Label>
                                                    <MultiSelect
                                                        className="multi_slct"
                                                        options={DayOptions}
                                                        value={selected}
                                                        onChange={(e) => {
                                                            setSelected(e)
                                                        }}
                                                        labelledBy="Select"
                                                        required
                                                    />
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={
                                                            AdapterMoment
                                                        }
                                                    >
                                                        <Form.Label>
                                                            Clinical Start Time
                                                        </Form.Label>
                                                        <TimePicker
                                                            value={rotationReq?.startTime ? rotationReq?.startTime : null}
                                                            className="form-control"
                                                            required
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                if (newValue && newValue._d != "Invalid Date") {
                                                                    setRotationReq({
                                                                        ...rotationReq,
                                                                        "start_time": moment(newValue._d).format("hh:mm:ss a"),
                                                                        "startTime": newValue._d
                                                                    })
                                                                }
                                                            }}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    required
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>
                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3 mui_dtpickr"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={
                                                            AdapterMoment
                                                        }
                                                    >
                                                        <Form.Label>
                                                            Clinical End Time
                                                        </Form.Label>
                                                        <TimePicker
                                                            minTime={rotationReq?.startTime ? moment(rotationReq?.startTime) : null}
                                                            value={rotationReq?.endTime ? rotationReq?.endTime : null}
                                                            className="form-control"
                                                            required
                                                            disabled={!rotationReq?.startTime}
                                                            onChange={(
                                                                newValue
                                                            ) => {
                                                                if (newValue && newValue._d != "Invalid Date") {
                                                                    setRotationReq({
                                                                        ...rotationReq,
                                                                        "end_time": moment(newValue._d).format("hh:mm:ss a"),
                                                                        "endTime": newValue._d
                                                                    })
                                                                }

                                                            }}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    required
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                                </Form.Group>

                                                <Form.Group
                                                    controlId="formFile"
                                                    className="mb-3"
                                                >
                                                    <Form.Label>
                                                        What are your Course
                                                        Objectives?
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        placeholder="Write your message here"
                                                        required
                                                        name='course_objective'
                                                        onChange={(e) => { handleChange(e) }}
                                                    />
                                                </Form.Group>
                                                <Form.Group
                                                    className="mb-3"
                                                    controlId="exampleForm.ControlTextarea1"
                                                >
                                                    <Form.Label>
                                                        Your Message
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={4}
                                                        placeholder="Write your message here"
                                                        required
                                                        name='message'
                                                        onChange={(e) => { handleChange(e) }}
                                                    />
                                                </Form.Group>
                                                <div className="text-center">
                                                    <Button
                                                        className="btn_theme mt-4"
                                                        type="submit"
                                                        variant=""
                                                    >
                                                        Submit Request
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={12}>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Type of Program
                                            </h4>
                                        </div>
                                        { }
                                        <div className="files_cards">
                                            <Row>
                                                {
                                                    programs && programs.map((curr, index) => {
                                                        return (


                                                            <Col sm="3" key={index} onClick={() => { navigate(`/Student/${curr._id}/programs/${schoolInfo.school_id}`) }}>
                                                                <div className="file_card mb-3">
                                                                    <div className="fldr_icn txt_prpl">
                                                                        <FaFolder />
                                                                    </div>
                                                                    <h5>{curr.program_name}</h5>
                                                                    {/* <p>900 files</p> */}
                                                                </div>
                                                            </Col>

                                                        )
                                                    })
                                                }
                                            </Row>

                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>


                            {profileData?.is_auth_sub_admin ? profileData?.auth_sub_admin_privilege?.administrative_docs == "true" &&
                                <Col md={12} >
                                    <Card className="pg_card" ref={Administrative_Ref}>
                                        <Card.Body>
                                            <div className="card_hdng" >
                                                <h4 className="mb-0">
                                                    Administrative Files
                                                </h4>
                                            </div>

                                            <FileStructure shardFiles={files} />

                                        </Card.Body>
                                    </Card>
                                </Col> : <Col md={12}>
                                <Card className="pg_card" ref={Administrative_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Administrative Files
                                            </h4>
                                        </div>

                                        <FileStructure shardFiles={files} />

                                    </Card.Body>
                                </Card>
                            </Col>}


                            {profileData?.is_auth_sub_admin ? profileData?.auth_sub_admin_privilege?.my_files === "true" && <Col md={12}>
                                <Card className="pg_card" ref={Files_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                My Files
                                            </h4>
                                        </div>
                                        <MyCreatedFilesStructure shardFiles={myCreatedFile} deleteFile={deleteFile} shareFolders={shareFolders} />

                                    </Card.Body>
                                </Card>
                            </Col> : <Col md={12}>
                                <Card className="pg_card" ref={Files_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                My Files
                                            </h4>
                                        </div>
                                        <MyCreatedFilesStructure shardFiles={myCreatedFile} deleteFile={deleteFile} shareFolders={shareFolders} />

                                    </Card.Body>
                                </Card>
                            </Col>}

                            {profileData?.is_auth_sub_admin ? profileData?.auth_sub_admin_privilege?.student_contracts === "true" && <Col md={12}>
                                <Card className="pg_card" ref={Contracts_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Student Contracts
                                            </h4>
                                        </div>
                                        <SignaturedContracts shardFiles={signaturedFolders} />



                                    </Card.Body>
                                </Card>
                            </Col> : <Col md={12}>
                                <Card className="pg_card" ref={Contracts_Ref}>
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Student Contracts
                                            </h4>
                                        </div>
                                        <SignaturedContracts shardFiles={signaturedFolders} />



                                    </Card.Body>
                                </Card>
                            </Col>}

                        </Row>
                    </div>



                    <Modal show={modalOpen} onHide={modalToggle} className="main_modl">
                        <Modal.Header closeButton>
                            <Modal.Title className="text_theme">
                                Department Information
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="prfl_flds">
                                <Form>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label>Department's Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="other_department"
                                            value={rotationReq?.other_program_info && rotationReq?.other_program_info}
                                            placeholder="Enter Department's Name"
                                            onChange={(e) => { handleChange(e) }}
                                        />
                                    </Form.Group>

                                    <Form.Group
                                        controlId="formFile"
                                        className="mb-3 mui_dtpickr"
                                    >

                                    </Form.Group>
                                    <div className="text-center">
                                        <Button
                                            className="btn_theme mt-4"
                                            variant=""
                                            onClick={() => { modalToggle() }}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Body>
                    </Modal>

                    -
                    <Modal show={fileOpen.isFileOpen} onHide={() => { setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }) }} className="main_modl">
                        <Modal.Header closeButton>
                            <Modal.Title className="text_theme">
                                Create New File
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="prfl_flds">
                                <Form
                                    onSubmit={async (e) => {
                                        e.preventDefault()
                                        await createFile(fileName).then(res => setFileOpen({ ...fileOpen, isFileOpen: !fileOpen.isFileOpen }))

                                    }}
                                >
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label> Add New File</Form.Label>
                                        <Form.Control
                                            type="file"
                                            fullWidth
                                            name="file"
                                            required
                                            placeholder="Enter Department's Name"
                                            onChange={(e) => {
                                                const fileData = new FormData();
                                                fileData.append("name", e.target.files[0]);
                                                fileData.append("type", "file");
                                                fileData.append("createdBy_id", idSchool);
                                                setFileName(fileData);
                                            }}
                                        />
                                    </Form.Group>

                                    {/* <Form.Group
                                        controlId="formFile"
                                        className=" mui_dtpickr"
                                    >

                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <Form.Label>
                                                Expiration Date (optional)
                                            </Form.Label>

                                            <DatePicker
                                                placeholder="Enter Graduation Date"
                                                className="form-control"
                                                value={fileName?.expiration_time ? fileName?.expiration_time : null}
                                                onChange={(
                                                    newValue

                                                ) => {
                                                    if (newValue && newValue._d) {
                                                        setFileName({
                                                            ...fileName,
                                                            "expiration_time": newValue._d,
                                                        })
                                                        // fileData.append("expiration_date", newValue._d);
                                                        // setFileName(fileData)
                                                    }

                                                }}


                                                renderInput={(
                                                    params
                                                ) => (
                                                    <TextField
                                                        {...params}
                                                        required
                                                    />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Form.Group> */}

                                    <Form.Group
                                        controlId="formFile"
                                        className="mb-3 mui_dtpickr"
                                    >

                                    </Form.Group>
                                    <div className="text-center">
                                        <Button
                                            className="btn_theme mt-4"
                                            variant=""
                                            type="submit"
                                        >
                                            Create
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal show={fileOpen.isFolderOpen} onHide={() => { setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }) }} className="main_modl">
                        <Modal.Header closeButton>
                            <Modal.Title className="text_theme">
                                Create New Folder
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="prfl_flds">
                                <Form>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label> Add New Folder</Form.Label>
                                        <Form.Control
                                            type="text"
                                            fullWidth
                                            name="file"
                                            placeholder="Enter Folder's Name"
                                            onChange={(e) => {
                                                setFolderName({
                                                    name: e.target.value,
                                                    type: "folder",
                                                    createdBy_id: idSchool
                                                });
                                            }}
                                        />
                                    </Form.Group>

                                    <Form.Group
                                        controlId="formFile"
                                        className="mb-3 mui_dtpickr"
                                    >

                                    </Form.Group>
                                    <div className="text-center">
                                        <Button
                                            className="btn_theme mt-4"
                                            variant=""
                                            onClick={async (e) => {
                                                await createFile(folderName).then(res => setFileOpen({ ...fileOpen, isFolderOpen: !fileOpen.isFolderOpen }))

                                            }}
                                        >
                                            Create
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Body>
                    </Modal>
                </Container>
            </div >
            <Footer />
        </div >
    );
};

export default SchoolDashboard;
